import { render } from "./KBPreviewList.vue?vue&type=template&id=4bea9280&scoped=true"
import script from "./KBPreviewList.vue?vue&type=script&lang=js"
export * from "./KBPreviewList.vue?vue&type=script&lang=js"

import "./KBPreviewList.vue?vue&type=style&index=0&id=4bea9280&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bea9280"]])

export default __exports__